import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { Path } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi, normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function usePaths(params: Record<string, string> = {}) {
  return useList<Path>(`${API_URL}/admin/paths`, {
    query: params,
  })
}

export function usePath(id: number | undefined) {
  return useDetail<Path>(`${API_URL}/admin/paths`, id?.toString())
}

export function useCreatePath() {
  return useCreate<Path>(`${API_URL}/admin/paths`)
}

export function useUpdatePath() {
  return useUpdate<Path>(`${API_URL}/admin/paths`)
}

export function useDeletePath() {
  return useDelete(`${API_URL}/admin/paths`)
}

export function usePartialUpdatePath() {
  return usePartialUpdate<Path>(`${API_URL}/admin/paths`)
}

export function useDeleteMultiPath() {
  return useAction(`${API_URL}/admin/paths/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function usePathLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/paths/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Path>
  }, [])
}

export function usePathsLazy(params: Record<string, string | number | Array<number>> = {}) {
  const auth = useAuth()
  return useCallback((paramsOverride: Record<string, string | number | Array<number>> = {}) => {
    const combinedParams = { ...params, ...paramsOverride }
    const qs = normalizeParams(combinedParams).toString()
    return fetchApi(`${API_URL}/admin/paths?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Path[] }>
  }, [])
}
